module.exports = __webpack_public_path__ + "img/meauicon2.df453a15.svg";